import { Typography } from '@mui/material';

import {
  CasMRTCellRenderCurrrency,
  CasMRTCellRenderDate,
  CasMRTCellRenderNumberWithCommas,
  CasMRTable,
  ICasMRTCellProps,
} from 'src/compass/shared/components';

import { CommissionsTabProps } from '../PreliminaryCommissions';
import PreliminaryCommissionsTopToolbar from '../PreliminaryCommissionsTopToolbar';

export default function PreliminaryAccrualsTab({ data, exportUrl }: CommissionsTabProps) {
  const columns = [
    {
      accessorKey: 'employeeShortName',
      header: 'Employee',
    },
    {
      accessorKey: 'effectiveDate',
      Cell: CasMRTCellRenderDate,
    },
    {
      accessorKey: 'reinsuranceYear',
    },
    {
      accessorKey: 'policy',
    },
    {
      accessorKey: 'sce',
      header: 'SCE#',
    },
    {
      accessorKey: 'insuredName',
      header: 'Insured',
    },
    {
      accessorKey: 'sts',
      muiTableBodyCellProps: ({ cell }: Pick<ICasMRTCellProps, 'cell'>) => ({
        style: {
          backgroundColor: cell.getValue() ? 'yellow' : 'inherit',
        },
      }),
    },
    {
      accessorKey: 'endDate',
      Cell: CasMRTCellRenderDate,
    },
    {
      accessorKey: 'headCount',
      header: 'HC',
      Cell: CasMRTCellRenderNumberWithCommas,
    },
    {
      accessorKey: 'basePremium',
      header: 'Premium',
      Cell: CasMRTCellRenderCurrrency,
    },
    {
      accessorKey: 'description',
    },
    {
      accessorKey: 'schedule',
    },
    {
      accessorKey: 'rate',
    },
    {
      accessorKey: 'adjusted',
    },
    {
      accessorKey: 'commission',
      Cell: CasMRTCellRenderCurrrency,
    },
    {
      accessorKey: 'crop',
    },
  ];

  if (!data || data.result.length === 0)
    return <Typography>No commissions earned on endorsements effective this month</Typography>;

  return (
    <>
      <Typography>Commissions earned (accrued) on endorsements effective this month</Typography>
      <CasMRTable
        data={data?.result || []}
        columns={columns}
        renderTopToolbarCustomActions={() => (
          <PreliminaryCommissionsTopToolbar
            total={data?.total}
            totalLabel="Total Accrued Commissions"
            exportUrl={exportUrl}
          />
        )}
        enableGrouping={false}
        enablePagination={false}
      />
    </>
  );
}
